import React, { useCallback, useEffect, useMemo } from 'react';
import DF from 'DisplayFramework';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import DataGrid from 'components/DataGrid';
import { Form, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { indexBy, shouldUpdateCompare } from 'utils/utils2';
import {
  AssetCatalogUpgradeResponse,
  ParAssetCatalogUpgrade,
} from 'services/assetconfig';
import { toCurrency } from 'utils/utils';
import AssetCatalogDetailsModal from './AssetCatalogDetailsModal';
import ModalControllerNV from 'components/ModalControllerNV';

type AsseCatalogDowngradeListProps = {
 DowngradeList:any[]
};
const AssetCatalogDowngradeList = (props: AsseCatalogDowngradeListProps) => {
  const { DowngradeList } = props;
  const [form] = useForm();
  const fieldName = 'downgrade';


  useEffect(() => {
    if (DowngradeList) {
      form.setFieldsValue({
        [fieldName]: DowngradeList.map((up: AssetCatalogUpgradeResponse) => ({
          ...up,
          catalogidupgrade: up.catalogid,
          assetlabel: up.assetlabel,
        })),
      });
    }
  }, [form, DowngradeList]);
  const getName = useCallback(
    (name: string) => (record: ParAssetCatalogUpgrade) => {
      const actions = form.getFieldValue(fieldName);
      const index = indexBy(actions, 'catalogid')[record.catalogid];
      return [fieldName, index, name];
    },
    [form]
  );

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'catalogidupgrade',
        render: (value, record) => {
          return (
            <Form.Item name={getName('catalogidupgrade')(record)} noStyle>
              {value}
            </Form.Item>
          );
        },
        width: 20,
      },
      {
        dataIndex: 'assetlabel',
        render: (value, record) => {
          return (
            <Form.Item name={getName('assetlabel')(record)} noStyle>
              <ModalControllerNV
                modal={({ setVisible, visible }) => (
                  <AssetCatalogDetailsModal
                    title={record.assetlabel}
                    catalogid={record.catalogidupgrade}
                    visible={visible}
                    onCancel={() => setVisible(false)}
                  />
                )}
                content={({ setVisible, visible }) => (
                  <a onClick={() => setVisible(true)}>{value}</a>
                )}
              />
            </Form.Item>
          );
        },
        width: 40,
      },
      {
        dataIndex: 'assetnetamount',
        width: 20,
        render: (value, record) => (
          <Form.Item name={getName('assetnetamount')(record)} noStyle>
            {toCurrency(value, record.currcode)}
          </Form.Item>
        ),
      },
    ],
    [form, getName]
  );

  return (
    <DF.Provider pagcode="downgradelist">
      <Form form={form}>
        <Form.Item noStyle shouldUpdate={shouldUpdateCompare(fieldName)}>
          {({ getFieldValue }) => {
            return (
              <DataGrid
                rowKey="upid"
                columns={columns}
                titleComcode="DowngradeList"
                dataSource={getFieldValue(fieldName)}
                hideFilters
                extraActions={<Row style={{ height: 45 }} />}
              />
            );
          }}
        </Form.Item>
      </Form>
    </DF.Provider>
  );
};

export default AssetCatalogDowngradeList;
